import api from "@/api";

const localStorage = {
    getItem(...args) {
        try {
        return window.localStorage.getItem(...args);
        } catch (e) {
        return '';
        }
    },
    setItem(...args) {
        try {
        return window.localStorage.setItem(...args);
        } catch (e) {
        return '';
        }
    },
};
  
export default {
    namespaced: true,
    state: {
        listStyle: 'normal',
        configNameOptions: [],
        configCurrentId: '',
        pipelines: [],
        productType: '',
        buildRedirect: {},
        buildParams: {},
        pipelineDetail: {},
        filterParams: {},
        pagerInfo: {
            currentPage: 1,
            perPage: 20,
            total: 1,
            isLastPage: false
        }
    },
    getters: {
        getListStyle(state) {
            let listStyle = localStorage.getItem('pipelineListStyle') ? localStorage.getItem('pipelineListStyle') : 'normal';
            state.listStyle = listStyle;
            return state.listStyle;
        },
        getCurrentConfigId(state) {
            let currentConfigId = state.configNameOptions.length > 0 ? state.configNameOptions[0]['id'] : '';
            let saveCurrentConfigId = localStorage.getItem('currentConfigId');
            if (saveCurrentConfigId) {
                if (state.configNameOptions.length > 0) {
                    let currentInList = state.configNameOptions.some((item) => {
                        return item.id == saveCurrentConfigId;
                    })
                    if (currentInList) {
                        currentConfigId = saveCurrentConfigId;
                    }
                }
            }
            state.configCurrentId = Number(currentConfigId);
            return state.configCurrentId;
        }
    },
    mutations: {
        setListStyle(state, listStyle) {
            state.listStyle = listStyle;
            state.pipelines = [];
            localStorage.setItem('pipelineListStyle', listStyle);

        },
        setNameList(state, list) {
            state.configNameOptions = list;
        },
        setCurrentConfigId(state, currentValue) {
            state.configCurrentId = Number(currentValue);
            localStorage.setItem('currentConfigId', currentValue);
        },
        setPipelineItem(state, list) {
            state.pagerInfo.perPage = list['perPage'];
            state.pagerInfo.total = list['total'];
            state.pagerInfo.currentPage = list['currentPage'];
            //currentPage == -1 表示不分页
            state.pagerInfo.isLastPage = state.pagerInfo.currentPage == -1 || (list['currentPage'] * list['perPage'] >= list['total']);
            if(list['pipelines']) {
                if(state.listStyle == 'table' || state.pagerInfo.currentPage == 1 || state.pagerInfo.currentPage == -1){
                    state.pipelines = list['pipelines'];
                }else{
                    state.pipelines.splice(-1,0,...list['pipelines'])
                }
            }else{
                state.pipelines = [];
            }

        },
        setProductType(state, productType) {
            state.productType = productType;
        },
        setBuildRedirect(state, buildRedirect) {
            state.buildRedirect = buildRedirect;
        },
        setBuildParams(state, buildParams) {
            state.buildParams = buildParams;
        },
        setPipelineDetail(state, pipelineDetail) {
            state.pipelineDetail = pipelineDetail;
        },
        updatePipelineItem(state, pipeline) {
            state.pipelines.map((item, idx) => {
                if (item.id == pipeline.pipelineId) {
                    state.pipelines[idx]['lastBuild'] = pipeline;
                    let stages = [];
                    pipeline.stages.map((stage) => {
                        stages.push({
                            name: stage.name,
                            status: stage.status,
                            statusShowType: stage.statusShowType
                        })
                    });
                    state.pipelines[idx]['lastBuild']['stages'] = stages;
                }
            });
        },
        updatePipelineItemFollow(state, obj) {
            state.pipelines.map((item, idx) => {
                if (item.id == obj.pipelineId) {
                    state.pipelines[idx]['follow'] = obj.follow;
                }
            });
        },
        updatePipelineDetail(state, pipelineDetail) {
            if (state.pipelineDetail.id == pipelineDetail.id) {
                state.pipelineDetail['latestBuild'] = pipelineDetail['latestBuild'];
            }
        },
        updatePipelineRelateAutoTaskId(state, [pipelineId, autoTaskId]){
            state.pipelines.map((item, idx) => {
                if (item.id == pipelineId) {
                    state.pipelines[idx]['autoTaskId'] = autoTaskId;
                }
            });
        }
    },
    actions: {
        setListStyle({ commit }, listStyle) {
            commit('setListStyle', listStyle);
            api.base.addFeed('pipelineList::switchView', listStyle);
        },
        async loadProductList({ commit }) {
            let config = await api.pipeline.loadProductList();
            if (config) {
                commit('setNameList', config.options);
            }
        },
        async loadPipelines({ commit }, [pipelineConfigId, filterParams, currentPage]) {
            let pipelinesData = await api.pipeline.loadPipelineList(pipelineConfigId, filterParams, currentPage);
            commit('setPipelineItem', pipelinesData);
        },
        async loadBuildParams({ commit }, pipelineConfigId) {
            let buildData = await api.pipeline.loadBuildParams(pipelineConfigId);
            if (buildData) {
                commit('setBuildRedirect', buildData.isRedirect);
                commit('setBuildParams', buildData.params);
            }
        },
        setCurrentConfigId({ commit }, value) {
            commit('setCurrentConfigId', value);
        },
        async loadPipelineDetail({ commit }, pipelineId) {
            let pipelineDetail = await api.pipeline.loadPipelineDetail(pipelineId);
            if (pipelineDetail) {
                commit('setPipelineDetail', pipelineDetail);
            }
        },
        async changeFollowStatus({ commit }, [productId, pipelineId]) {
            commit
            await api.pipeline.changeFollowStatus(productId, pipelineId);
        },
        async saveAutoTask({ commit }, [pipelineId, autoTaskId, productId]) {
            commit
            await api.pipeline.saveAutoTask(pipelineId, autoTaskId, productId);
        },
        updatePipelineItem({ commit }, pipeline) {
            commit('updatePipelineItem', pipeline);
        },
        updatePipelineItemFollow({ commit }, [pipelineId, follow]) {
            commit('updatePipelineItemFollow', { "pipelineId": pipelineId, "follow": follow })
        },
        updatePipelineDetail({ commit }, pipelineDetail) {
            commit('updatePipelineDetail', pipelineDetail);
        },
        updatePipelineRelateAutoTaskId({ commit }, RelateInfo) {
            commit('updatePipelineRelateAutoTaskId', RelateInfo);
        },
    }
}